<template>
  <div>
    <div v-show="isShow">
      <div class="public-header">
        <div class="container">
          <el-row class="logo-slogan">
            <el-col :span="3">
              <img class="logo header-logo" src="/static/imgs/logo1.png" alt="logo">
            </el-col>
            <el-col :span="21" style="float: right;">
              <div class="fr head_box_ri" style="width:100%">
                <div class="wel">
                  <em class="left"></em>
                  <em class="mid">
                    <span v-if="profile.nickname || profile.userNewId">
                      {{profile.nickname}}&nbsp;({{profile.userNewId}})
                    </span>               
                    <span v-else>您好，欢迎您的到来！</span>
                    <img v-if="profile.nickname || profile.userId" :src="getSrc(profile.user_level_id)" style="display: inline;margin-left: 5px;margin-top: -2px;">
                    <el-button type="primary" v-if="profile.username" @click.native="logoutHandler">[退出]</el-button>
                    <span class="Mal20" v-else>
                      <el-button type="text" @click="register()">注册</el-button>
                      <el-button type="text" @click="login()">登录</el-button>
                    </span>                  
                    <span v-if="profile.nickname || profile.userId" class="Mal20">余额：
                      <a href="#" style="margin:0px;">
                        <font class="money money_bg" id="U_COINS" style="color:white;">{{profile.doudou.toLocaleString()}}</font>
                      </a>
                      <el-button style="width: 48px;padding-top: 5px;padding-left: 10px;" type="warning" v-if="profile.username" @click="showRecharge()">充值</el-button>
                    <i>/</i>
                      <el-button style="width: 48px;padding-top: 5px;padding-left: 10px;" type="danger" v-if="profile.username" @click="showExchange()">兑换</el-button>
                      银行：
                      <a href="#" style="margin:0px;">
                        <font class="money money_bg" id="U_BANK" style="color:white;">{{profile.deposit.toLocaleString()}}</font>
                      </a>
                      月度成长值：<font style="color:white;font-weight: bold;" id="U_CZZ">{{profile.growth}}</font>
                    </span>
                  </em>   
                  <em class="right"></em>
                  <div class="fl" style="margin-top:0px; width:35%;height:30px;line-height: 30px;float:right;">
                    <div id="wrapper">
                      <div class="first">
                        <MarqueeTips :speed="300"
                                    :content="MarqueeTipsContent"></MarqueeTips>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="head_prdu" style="color:black;">
                  <!--<li>
                    今日签到 <span style="font-size:15px;font-weight: bold;color:brown;">0</span> 人

                      <input id="sign" name="sign" class="nbtn" type="button" onclick="toSign()" value="立即签到"
                      style="display:inline;width:70px;height:26px;line-height: 26px;border-radius: 4px;cursor: pointer;outline: none;"/>

                  </li>-->
                  <li v-if="profile.isAgent == 1" @click="agentLogin">
                    代理功能
                  </li>
                  <li><a href="/wapnmain"><i class="ico2"></i>wap站点</a></li>
                  <li v-for="item in customerList">
                    <a href="#" @click="copyQQ(item.qq)" class="group4 cboxElement">
                      <i class="ico1"></i>{{item.name}}
                    </a>
                  </li>
                  <li style="cursor:pointer" @click="help"><i class="ico3"></i>帮助中心</li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="public-nav">
        <HeaderTabs :headerTabs=parentHeaderTabs></HeaderTabs>
      </div>
      <div class="public-content">
        <div style="width:100%;">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <div v-show="!isShow">
      <h1>{{systemNotice}}</h1>
    </div> 
    
    <el-dialog title="充值" :visible.sync="dialogFormRechargeVisible">
      <el-row :gutter="20" v-for="agent in agentList">
        <el-col :span="6"><div class="grid-content">{{agent.nickname}}</div></el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-input type="number" style="width:100px" v-model="agent.amount" autocomplete="off"></el-input>
          </div>
        </el-col>
        <el-col :span="6"><div class="grid-content"></div></el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-button type="primary" @click="submitRecharge(agent)">提交</el-button>
          </div>
        </el-col>
      </el-row>   
      <el-row :gutter="20">
        提示：充值前需先联系代理并确认好，充值10万豆只需输入100即可。
      </el-row>         
    </el-dialog>   
    
    <el-dialog title="兑换" :visible.sync="dialogFormExchangeVisible">
      <el-row :gutter="20" v-for="agent in agentList">
        <el-col :span="6"><div class="grid-content">{{agent.nickname}}</div></el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-input style="width:100px" v-model="agent.amount" autocomplete="off" @change="amountChange(agent.amount)"></el-input>
          </div>
        </el-col>
        <el-col :span="6"><div class="grid-content"></div></el-col>
        <el-col :span="6">
          <div class="grid-content">
            <el-button type="primary" @click="submitExchange(agent)">提交</el-button>
          </div>
        </el-col>
      </el-row>   
      <el-row :gutter="20">
        近7天有效流水{{sevenFlow.toLocaleString()}}豆，剩余可兑换流水{{leftSevenFlow.toLocaleString()}}豆，超出兑换{{overPrice.toLocaleString()}}豆，需收取{{payPrice.toLocaleString()}}豆，继续游戏可获取更多的兑换额度！
      </el-row>  
      <el-row :gutter="20">
        提示：兑换前需先联系代理并确认好！兑换需整百！
      </el-row> 
    </el-dialog>      
  </div>
</template>

<script>
  import HeaderTabs from "./HeaderTabs";
  import TabsHoverSection from "../components/TabsHoverSection";
  import MarqueeTips from 'vue-marquee-tips'
  import {mapState, mapActions} from 'vuex'

  export default {
    components: {
      HeaderTabs,
      TabsHoverSection,
      MarqueeTips
    },
    computed: {
      ...mapState('user', ['isLogin', 'profile'])
    },
    created() {
      if(this.profile.nickname || this.profile.userId){
        this.username = this.profile.nickname + ' ' + this.profile.userId
      }
      else{
        this.username = '欢迎您的到来！'
      }
      this.parentHeaderTabs = [
        {
          "text":"首页",
          "url":"/",
          "status":1
        },
        {
          "text": "推荐好友",
          "url": "/lotterylobby/1",
          "status": 0
        },
        {
          "text": "游戏中心",
          "url": "/forecastrecommend/1?type=g1",
          "status": 0
        },
        {
          "text": "活动中心",
          "url": "/charts/1",
          "status": 0
        },
        {
          "text": "通知公告",
          "url": "/live/1",
          "status": 0
        },
        {
          "text": "会员中心",
          "url": "/news",
          "status": 0
        },
        {
          "text": "排行榜",
          "url": "/helpCenter",
          "status": 0
        },
        {
          "text": "代理列表",
          "url": "/businessList",
          "status": 0
        }
      ]
      this.getSystemStatus({}).then(res => {
          var system = res.data
          if(system.systemStatus == 0){
            this.isShow = true
          }else{
            this.isShow = false
            this.systemNotice = system.systemNotice
          }
      })
      this.getCustomerCenter()
      this.getUserInfo({}).then(res => {
        if(typeof(res)!="undefined"){
          if(res.type == 4){
            this.$message.warning("非法会员，请联系管理员！");
            setTimeout(() => {
                this.logoutHandler()
            }, 300)            
          }
        }
      })
      this.noticeLast({}).then(res => {
          this.MarqueeTipsContent = res.content
      })      
    },
    data() {
      return {
        logoSloganTabsFooter: null,
        logoUrl: '',
        sologanUrl: '',
        parentHeaderTabs: [],
        footerDet: [],
        copyRight: '',
        isShowHoverBox: false,
        ruleForm: {
          avatar: '',
          id: '',
          nickname: '',
          username: '',
          bean: 0,
          experience: '',
          bank: 0,
          growth: 0,
          qq: '',
          weixin: '',
          phone: '',
          email: '',
          address: ''
        },
        username: '',
        isShow:true,
        systemNotice:'系统维护中',
        customerList:[],
        MarqueeTipsContent:'',
        dialogFormRechargeVisible: false,
        dialogFormExchangeVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        formLabelWidth: '120px',
        labelName: '代理',
        title: '充值',
        agentList:[],
        sevenFlow:0,
        leftSevenFlow:0,   
        overPrice:0,
        payPrice:0,     
      }
    },
    mounted() {},
    methods: {
      ...mapActions('user', ['logout','sysLogin','getUserInfo','queryAgent','recharge','rebateDetail']),
      ...mapActions('home', ['getSystemStatus','customerCenter','noticeLast']),
      logoutHandler () {
        this.logout().then(res => {
          this.$go('/home')
        })
      },
      login() {
        this.$router.push({path: '/'}) //跳转到新页面
        this.$router.push({path: '/login'}) //跳转到新页面
      },
      register() {
        this.$router.push({path: '/'}) //跳转到新页面
        this.$router.push({path: '/register'}) //跳转到新页面
      },
      help(){
        this.$router.push({path: '/help'}) //跳转到新页面
      },
      agentLogin(){
        window.location.href = "http://:8080/platform"      
      },
      getSrc(index){
        return "/static/imgs/vip/"+ (index-1) +".png"
      },
      getCustomerCenter() {
        var self = this
        this.customerList = []
        this.customerCenter({}).then(res => {
            var data = res.data
            data.forEach((item) => {
              var temp = {
                qq:item.cValue,
                name: item.cName
              } 
              self.customerList.push(temp)
            })
        })
      },
      queryAgentList(){
        var self = this
        this.queryAgent({}).then(res => {
          self.agentList = res
        })
      },
      copyQQ(qq){
        var self  = this
        this.$copyText(qq).then(function (e) {
          self.$message.info("复制成功");
        }, function (e) {
          self.$message.warning('复制失败');
        })        
      },
      submitRecharge(agent){
        var self = this
        this.recharge({
          amount: agent.amount,
          agentId: agent.agentId,
          type: 1          
        }).then(res => {
          self.dialogFormRechargeVisible = false
        })        
      },
      submitExchange(agent){
        var self = this
        this.recharge({
          amount: agent.amount,
          agentId: agent.agentId,
          type: 2         
        }).then(res => {
          self.dialogFormExchangeVisible = false
        })        
      },
      queryRebateDetail(params){
        var self = this
        self.rebateDetail(params).then(res =>{
          if(res){
            self.p1 = res.name;
            self.imgUrl = res.primary_pic_url;
            self.desc = res.goods_desc;
            self.goods_sn = res.goods_sn
            self.market_price = res.market_price
            self.sevenFlow = res.sevenFlow
            self.leftSevenFlow = res.leftSevenFlow
            self.overPrice = res.overPrice
            self.payPrice = res.payPrice  
            self.sumPrice = self.market_price  
            self.redeemLimitStatus = res.redeemLimitStatus
            self.redeemLimitSeveral = res.redeemLimitSeveral
            self.redeemLimitPay = res.redeemLimitPay             
          }
        })        
      },
      showRecharge(){
        this.queryAgentList()
        this.dialogFormRechargeVisible = true
      },
      showExchange(){
        this.queryAgentList()
        this.dialogFormExchangeVisible = true
        let params = {marketPrice:100}
        this.queryRebateDetail(params)
      },
      amountChange(amount){
        let params = {marketPrice:amount}
        this.queryRebateDetail(params)
      }
    },
  };
</script>

<style lang="less">
  @import url(../assets/css/public.less);
  @import url(../assets/css/layout.less);
</style>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  </style>




// WEBPACK FOOTER //
// src/components/Layout.vue